import { apiRequest, jsonBody } from "../api/client";
import type { RsvpRecord, WishRecord } from "../types/wedding";

export interface InvitationServices {
  rsvps: {
    submit(input: unknown): Promise<RsvpRecord>;
  };
  wishes: {
    list(includePending?: boolean): Promise<WishRecord[]>;
    submit(input: unknown): Promise<WishRecord>;
  };
}

const previewServices: InvitationServices = {
  rsvps: {
    async submit(input) {
      const value = input as { name: string; attendance: string; guests: number };
      return { id: crypto.randomUUID(), ...value, createdAt: new Date().toISOString() };
    }
  },
  wishes: {
    async list() { return []; },
    async submit(input) {
      const value = input as { name: string; message: string };
      return { id: crypto.randomUUID(), ...value, status: "approved", createdAt: new Date().toISOString() };
    }
  }
};

export function createPreviewServices() {
  return previewServices;
}

export function createPublicServices(slug: string): InvitationServices {
  return {
    rsvps: {
      async submit(input) {
        const response = await apiRequest<{ ok: true; id: string }>(`/api/public/${encodeURIComponent(slug)}/rsvp`, { method: "POST", body: jsonBody(input) });
        const value = input as { name: string; attendance: string; guests: number };
        return { id: response.id, ...value, createdAt: new Date().toISOString() };
      }
    },
    wishes: {
      async list() {
        const response = await apiRequest<{ ok: true; wishes: WishRecord[] }>(`/api/public/${encodeURIComponent(slug)}/wishes`);
        return response.wishes;
      },
      async submit(input) {
        const response = await apiRequest<{ ok: true; id: string; status: WishRecord["status"] }>(`/api/public/${encodeURIComponent(slug)}/wishes`, { method: "POST", body: jsonBody(input) });
        const value = input as { name: string; message: string };
        return { id: response.id, ...value, status: response.status, createdAt: new Date().toISOString() };
      }
    }
  };
}
